function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmartphoneVibrateIcon = function SvgSmartphoneVibrateIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211e48"
    },
    d: "M30.89 421.901c-8.054 0-14.582-6.53-14.582-14.582V55.112C16.308 24.724 41.031 0 71.419 0h229.915c30.389 0 55.112 24.724 55.112 55.112V283.68c0 8.052-6.528 14.582-14.582 14.582-8.054 0-14.582-6.53-14.582-14.582V55.112c0-14.309-11.641-25.949-25.949-25.949H71.419c-14.308 0-25.947 11.639-25.947 25.949v352.207c0 8.054-6.53 14.582-14.582 14.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0dacc"
    },
    d: "M30.889 402.586v54.302c0 22.385 18.146 40.531 40.531 40.531h229.915c22.385 0 40.531-18.146 40.531-40.531v-54.302H30.889"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211e48"
    },
    d: "M301.334 512H71.419c-30.389 0-55.111-24.724-55.111-55.112v-54.302c0-8.052 6.528-14.582 14.582-14.582h310.976c8.054 0 14.582 6.53 14.582 14.582v54.302C356.447 487.276 331.725 512 301.334 512zM45.472 417.168v39.72c0 14.309 11.639 25.949 25.947 25.949h229.915c14.308 0 25.949-11.639 25.949-25.949v-39.72H45.472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211e48"
    },
    d: "M210.419 464.343h-46.834c-8.054 0-14.582-6.53-14.582-14.582s6.528-14.582 14.582-14.582h46.834c8.054 0 14.582 6.53 14.582 14.582 0 8.053-6.529 14.582-14.582 14.582zM341.865 435.344c-8.054 0-14.582-6.53-14.582-14.582V353.97c0-8.052 6.528-14.582 14.582-14.582 8.054 0 14.582 6.53 14.582 14.582v66.793c0 8.051-6.528 14.581-14.582 14.581zM443.389 348.647a14.547 14.547 0 0 1-11.16-5.188c-5.188-6.159-4.401-15.358 1.759-20.547a92.62 92.62 0 0 0 5.812-5.327c35.657-35.657 35.657-93.679-.001-129.338-5.694-5.694-5.694-14.928 0-20.623 5.694-5.693 14.926-5.691 20.622 0 47.028 47.031 47.028 123.553 0 170.584a122.355 122.355 0 0 1-7.645 7.01 14.53 14.53 0 0 1-9.387 3.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211e48"
    },
    d: "M403.404 328.187a14.554 14.554 0 0 1-11.46-5.553c-4.987-6.323-3.904-15.492 2.421-20.479a63.767 63.767 0 0 0 5.553-4.93c24.431-24.432 24.431-64.19-.003-88.622-5.694-5.694-5.694-14.928 0-20.623 5.694-5.693 14.928-5.693 20.623 0 35.805 35.805 35.805 94.064 0 129.871a92.732 92.732 0 0 1-8.112 7.202 14.52 14.52 0 0 1-9.022 3.134z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmartphoneVibrateIcon);
export default ForwardRef;